import { Immutable } from "immer";
import React from "react";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./index.module.scss";

type IProps = Immutable<{
    backgroundImage: string;
    variant?: "reviews" | "reviewsEmpty";
    className?: string;
}>;

/**
 * The full-bleed background hero div shared by the ReviewsPage and OfferPage
 * templates. ``backgroundImage`` is the complete CSS value; each page builds
 * its own ``url(...)`` string.
 */
export const PageHero = (props: IProps): React.JSX.Element => (
    <div
        className={concatClassNames([
            styles.hero,
            props.variant ? styles.heroReviews : null,
            props.variant === "reviewsEmpty" ? styles.heroReviewsEmpty : null,
            props.className,
        ])}
        style={{ backgroundImage: props.backgroundImage }}
    />
);
